import React from 'react';
import PropTypes from 'prop-types';

export default function Tickets(props) {
  const { height, width, iconColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 1027 1026" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M513.5 0C412.038 0 312.855 30.0869 228.493 86.4561C144.13 142.825 78.3778 222.945 39.55 316.683C0.722275 410.422 -9.43683 513.569 10.3574 613.081C30.1516 712.593 79.0101 804.001 150.754 875.746C222.499 947.49 313.907 996.348 413.419 1016.14C512.931 1035.94 616.078 1025.78 709.817 986.95C803.555 948.122 883.675 882.37 940.044 798.007C996.413 713.645 1026.5 614.462 1026.5 513C1026.44 376.962 972.374 246.513 876.181 150.319C779.987 54.1261 649.538 0.0591084 513.5 0ZM565.291 821.291H461.709V717.709H565.291V821.291ZM564.8 665.785H462.2C462.2 500.732 616.1 512.375 616.1 409.775C616.053 382.554 605.237 356.457 586.014 337.183C566.79 317.91 540.721 307.026 513.5 306.908C486.453 307.287 460.616 318.181 441.464 337.284C422.312 356.386 411.35 382.194 410.9 409.24H308.3C308.336 354.818 329.989 302.638 368.496 264.181C407.004 225.724 459.212 204.138 513.634 204.174C568.056 204.209 620.236 225.863 658.693 264.37C697.15 302.878 718.736 355.085 718.7 409.508C718.7 537.892 564.8 552.479 564.8 665.785Z"
        fill={iconColor}
      />
    </svg>
  );
}

Tickets.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string
};

Tickets.defaultProps = {
  width: 22,
  height: undefined,
  iconColor: '#000'
};
